import { InterestedOptions } from '@revelio/core';

import { Button, Select, Spinner, Stack, TextInput, uiStyles } from './ui';

interface IInterestedOption {
  label: string | InterestedOptions;
  value: InterestedOptions | null;
}

const interestedOptions: IInterestedOption[] = [
  {
    label: 'Talent Intelligence',
    value: InterestedOptions.Talent_Intelligence,
  },
  {
    label: 'Workforce Planning & Analytics',
    value: InterestedOptions.Workforce_Planning_and_Analytics,
  },
  {
    label: 'Talent Acquisition',
    value: InterestedOptions.Talent_Acquisition,
  },
  {
    label: 'Investment Management',
    value: InterestedOptions.Investment_Management,
  },
  {
    label: 'Product Management',
    value: InterestedOptions.Product_Management,
  },
  {
    label: 'Academic Research',
    value: InterestedOptions.Academic_Research,
  },
];

/**
 * The "Tell us a little about yourself" fields, shared by signup step 2 (both
 * variants) and the returning-user /personalize page. Organization and
 * interest are BOTH required — the button stays disabled until they're filled,
 * the same affordance the rest of the flow uses.
 */
export function AboutYouFields({
  organization,
  onOrganizationChange,
  interest,
  onInterestChange,
  onContinue,
  loading,
  disabled = false,
}: {
  organization: string;
  onOrganizationChange: (value: string) => void;
  interest: string;
  onInterestChange: (value: string) => void;
  onContinue: () => void;
  loading: boolean;
  disabled?: boolean;
}) {
  return (
    <Stack gap="16px">
      <TextInput
        placeholder="Organization"
        aria-label="Organization"
        autoComplete="organization"
        value={organization}
        onChange={(event) => onOrganizationChange(event.target.value)}
      />
      <Select
        placeholder="What are you most interested in?"
        aria-label="What are you most interested in?"
        value={interest}
        onChange={(event) => onInterestChange(event.target.value)}
      >
        {interestedOptions.map((option) => (
          <option key={option.label} value={option.value ?? ''}>
            {option.label}
          </option>
        ))}
      </Select>
      <Button
        style={{ marginTop: 'clamp(0px, 1.86vh, 19px)' }}
        disabled={!interest || !organization.trim() || disabled || loading}
        onClick={onContinue}
      >
        {loading ? (
          <span className={uiStyles.buttonLoading}>
            Loading...
            <Spinner size="xs" />
          </span>
        ) : (
          'Continue'
        )}
      </Button>
    </Stack>
  );
}
